export class CartRequest {
  code: string;
  uom: string;
  quantity: number;
  product_category: string;
}

export interface Cart {
  id: string;
  product_code: string;
  uom: string;
  quantity: number;
  price: number;
  total_price: number;
  net_price: number; // penambahan buat CR10
  productPriceNetValue: number; // penambahan buat CR10
  productPriceValue: number; // penambahan buat CR10
  promotions: any;
  stock: number;
  last_update_stock: Date;
  plant: string;
  item_name: string;
  principal_name: string;
  image_url: string;
  image: {
    image_web: string,
    image_mobile: string
  };

  alert_message: string;

  // CR-15
  expiry_date: string;
}

export interface CheckoutPreview {
  constraint_date: number;
  initial_buffer: number;
  maximum_buffer: number;
  orders: Order[];
  grand_total: number;
}

export interface Order {
  product_code: string;
  product_name: string;
  principal_name: string;
  image_url: string;
  estimate_stocks: number;
  price: number;
  total_price: number;
  quantity: number;
  net_value: number;
  image: {
    image_web: string,
    image_mobile: string
  };

  // CR-15
  expiry_date: string;
}

export class CheckoutReq {
  // PONumber: string;
  // PODate: string;
  // ShipToPartyCode: string;
  // PaymentMethod: number;
  // File: File;
  // Pin: string;

  RequestId: string;
  PurchaseOrderNumber: string;
  ShipToPartyCode: string;
  CheckoutMethod: number;
  File: File;
  Pin: string;
}

export class CheckoutReqGT {
  // PONumber: string;
  // PODate: string;
  // ShipToPartyCode: string;
  // PaymentMethod: number;
  // File: File;
  // Pin: string;

  // RequestId: string;
  PurchaseOrderNumber: string;
  Address: string;
  ShipToPartyCode: string;
  // CheckoutMethod: number;
  File: File;
  // Pin: string;
}

export class InvalidProduct {
  client_code: string;
  client_name: string;
  product_code: string;
  product_name: string;
  quantity: number;
  unit_of_measure: string;
  message: string;
}

export class ClosingDate {
  isClosing: boolean;
  startDate: Date;
  endDate: Date;
}
